<div
  class="dropdown-wrapper"
  (onShown)="open()"
  (onHidden)="close()"
  [ngClass]="{ show: isOpen && !disabled, leftAlign: leftAlign }"
  [class]="type"
  (keydown)="handleKeydown($event)"
  (click)="toggle()"
>
  <button
    #dropdownTrigger
    [class.noToggle]="options.length < 1 || disabled"
    type="button"
    class="trigger"
    aria-haspopup="listbox"
    attr.aria-controls="{{ 'dropdown-basic-' + id }}"
    [attr.aria-expanded]="isOpen"
    [attr.disabled]="disabled || null"
  >
    <span
      class="label"
      [ngClass]="{ boldedBlue: isBoldedBlue }"
      data-test-id="dropdown-label"
    >
      {{ triggerValue }}
    </span>
    <ng-container *ngIf="options.length > 0 && !disabled">
      <cigna-icon
        *ngIf="expandIcon"
        class="expand-icon"
        [type]="expandIcon"
        data-test-id="dropdown-button"
      ></cigna-icon>
      <span
        class="caret"
        *ngIf="!expandIcon"
        data-test-id="dropdown-button"
      ></span>
    </ng-container>
  </button>
  <ul
    #listbox
    id="{{ 'dropdown-basic-' + id }}"
    class="dropdown-menu"
    data-test-id="list-dropdown-menu"
    [ngClass]="{ show: isOpen }"
    role="listbox"
    tabindex="-1"
  >
    <ng-content></ng-content>
  </ul>
</div>
